/* NK Pro sections — shared behaviour (reveal on scroll, before/after slider, accordion) */
(function () {
  if (window.__nkpInit) return;
  window.__nkpInit = true;
  var design = document.documentElement.classList.contains('shopify-design-mode') || (window.Shopify && window.Shopify.designMode);
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    var els = (root || document).querySelectorAll('.nkp-reveal:not(.is-in)');
    if (!els.length) return;
    if (design || reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el, i) { el.style.transitionDelay = (Math.min(i % 6, 5) * 0.06) + 's'; io.observe(el); });
  }

  function compare(root) {
    (root || document).querySelectorAll('[data-nkp-compare]:not([data-ready])').forEach(function (box) {
      box.setAttribute('data-ready', '');
      var range = box.querySelector('input[type="range"]');
      if (!range) return;
      var set = function () { box.style.setProperty('--pos', range.value + '%'); };
      range.addEventListener('input', set);
      set();
    });
  }

  function accordion(root) {
    (root || document).querySelectorAll('[data-nkp-accordion]:not([data-ready])').forEach(function (list) {
      list.setAttribute('data-ready', '');
      var single = list.hasAttribute('data-single');
      var items = list.querySelectorAll('details');
      items.forEach(function (d) {
        var sum = d.querySelector('summary');
        var body = d.querySelector('[data-nkp-body]');
        sum.addEventListener('click', function (ev) {
          ev.preventDefault();
          var open = !d.open;
          if (open && single) items.forEach(function (o) { if (o !== d && o.open) toggle(o, false); });
          toggle(d, open);
        });
        function toggle(det, open) {
          var b = det.querySelector('[data-nkp-body]');
          if (reduce || !b || !b.animate) { det.open = open; return; }
          if (open) {
            det.open = true;
            b.animate([{ height: '0px', opacity: 0 }, { height: b.scrollHeight + 'px', opacity: 1 }], { duration: 260, easing: 'ease-out' });
          } else {
            var a = b.animate([{ height: b.scrollHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 200, easing: 'ease-in' });
            a.onfinish = function () { det.open = false; };
          }
        }
        d._nkpToggle = toggle;
        if (!body) return;
      });
    });
  }

  function init(root) { reveal(root); compare(root); accordion(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* NK Pro festive: countdowns, copy code, delivery-date status, product delivery message */
(function () {
  if (window.__nkpFestive) return; window.__nkpFestive = true;
  function parse(iso) { if (!iso || iso.indexOf('T') < 1) return null; var t = Date.parse(iso); return isNaN(t) ? null : t; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function split(ms) { var s = Math.max(0, Math.floor(ms / 1000)); return { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 }; }
  function countdown(root) {
    (root || document).querySelectorAll('[data-nkp-countdown]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '');
      var end = parse(el.getAttribute('data-end')), start = parse(el.getAttribute('data-start'));
      var live = el.querySelector('[data-cd-live]'), ended = el.querySelector('[data-cd-ended]');
      var lblS = el.querySelector('[data-cd-starts]'), lblE = el.querySelector('[data-cd-ends]');
      var shell = el.closest('.shopify-section') || el.closest('section');
      if (!end) return;
      function tick() {
        var now = Date.now(), target = end, before = start && now < start;
        if (before) target = start;
        if (lblS) lblS.hidden = !before; if (lblE) lblE.hidden = !!before;
        var left = target - now;
        if (!before && left <= 0) {
          if (live) live.hidden = true;
          if (el.getAttribute('data-after') === 'hide' && !document.documentElement.classList.contains('shopify-design-mode')) { if (shell) shell.style.display = 'none'; }
          else if (ended) ended.hidden = false;
          clearInterval(t); return;
        }
        var p = split(left);
        ['d', 'h', 'm', 's'].forEach(function (k) { var n = el.querySelector('[data-cd="' + k + '"]'); if (n) n.textContent = pad(p[k]); });
      }
      var t = setInterval(tick, 1000); tick();
    });
  }
  function copy(root) {
    (root || document).querySelectorAll('[data-nkp-copy]:not([data-ready])').forEach(function (b) {
      b.setAttribute('data-ready', '');
      b.addEventListener('click', function () {
        var code = b.getAttribute('data-nkp-copy'), msg = b.querySelector('[data-copy-msg]');
        var done = function () { if (msg) { msg.textContent = b.getAttribute('data-copied') || 'Copied!'; setTimeout(function () { msg.textContent = ''; }, 2000); } };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
      });
    });
  }
  function endOfDay(dateStr, tz) { if (!/^\d{4}-\d{2}-\d{2}$/.test(dateStr || '')) return null; return parse(dateStr + 'T23:59:59' + (tz || '+00:00')); }
  function dates(root) {
    (root || document).querySelectorAll('[data-nkp-dates]:not([data-ready])').forEach(function (box) {
      box.setAttribute('data-ready', '');
      var tz = box.getAttribute('data-tz');
      box.querySelectorAll('[data-date]').forEach(function (row) {
        var chip = row.querySelector('[data-chip]'); if (!chip) return;
        var end = endOfDay(row.getAttribute('data-date'), tz); if (!end) return;
        var left = end - Date.now(), days = Math.ceil(left / 86400000), state, txt;
        if (left <= 0) { state = 'closed'; txt = box.getAttribute('data-l-closed'); }
        else if (days <= 1) { state = 'today'; txt = box.getAttribute('data-l-today'); }
        else { state = 'open'; txt = (box.getAttribute('data-l-open') || '').replace('[days]', days); }
        if (!txt) return;
        chip.textContent = txt; chip.setAttribute('data-state', state); chip.hidden = false;
      });
    });
  }
  function xmas(root) {
    (root || document).querySelectorAll('[data-nk-xd]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '');
      var end = parse(el.getAttribute('data-end')), before = el.querySelector('[data-xd-before]'), after = el.querySelector('[data-xd-after]');
      var out = el.querySelector('[data-xd-time]');
      if (!end) return;
      function tick() {
        var left = end - Date.now();
        if (left <= 0) { if (before) before.hidden = true; if (after) after.hidden = false; else el.hidden = true; clearInterval(t); return; }
        var p = split(left);
        if (out) out.textContent = (p.d > 0 ? p.d + 'd ' : '') + p.h + 'h ' + pad(p.m) + 'm';
        if (before) before.hidden = false;
      }
      var t = setInterval(tick, 30000); tick();
    });
  }
  function init(root) { countdown(root); copy(root); dates(root); xmas(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
